import {ES, Link, RunInAction, RunInAction_Set, TextPlus} from "web-vcore";
import moment from "moment";
import {Button, CheckBox, Column, Div, Grid, Row, Select, Spinner, Text, TextInput} from "react-vcomponents";
import {ScrollView} from "react-vscrollview";
import {GetEntries} from "js-vextensions";
import React, {useState} from "react";
import {observer} from "mobx-react";
import {E, StartDownload} from "js-vextensions";
import {GetWordsInDreamSegment_Array, JournalEntry, JournalSegment} from "../../../Server/DB/journalEntries/@JournalEntry.js";
import {CreateAccessor, observer_mgl} from "mobx-graphlink";
import {store} from "../../../Store/index.js";
import {GetDreamTitle} from "../../../Server/DB/journalEntries/$journalEntry.js";

export const DreamPreview = observer_mgl((props: {journalEntry: JournalEntry, dream: JournalSegment})=>{
	const {journalEntry, dream} = props;
	const uiState = store.main.journal;
	const title = GetDreamTitle(dream);
	const words = GetWordsInDreamSegment_Array(dream, "longText", false, false).length;
	const selected = uiState.dreamList_selectedDream == dream.id;
	return (
		<Link style={ES(
			{
				position: "relative", display: "flex", borderRadius: 5,
				backgroundColor: "rgba(255,255,255,.2)",
			},
			title == null && {color: "orange"},
			//selected && {color: "rgba(0,255,255,1)"},
			//selected && {backgroundColor: "rgba(100,100,0,1)"},
			selected && {textDecoration: "underline"},
		)}
			actionFunc={s=>{
				// not all journal-segments/dreams have an ID atm; so fallback to opening the journal-entry in that case
				if (dream.id != null && uiState.dreamList_sidePanel_show) {
					s.main.journal.dreamList_selectedDream = dream.id;
				} else {
					s.main.journal.selectedJournalEntry = journalEntry.id;
				}
			}}
			onContextMenu={e=>e.nativeEvent["passThrough"] = true}
		>
			<div style={{position: "absolute", top: 0, left: 0, width: dream.mappingProgress?.ToPercentStr() ?? "0%", height: "100%", backgroundColor: "rgba(100,150,240,1)"}}/>
			<span style={{position: "relative"}}>{title?.length ? title : "(unnamed)"} [{words}]</span>
		</Link>
	);
});